<template lang="pug">
  .objects-tko-filter
    .objects-tko-filter__buttons
      button.reset-btn.button(@click="clearTkoFilter") Показать все объекты
      button.reset-btn.button(@click="changeTkoFilter('1')") Объекты ТКО
      button.reset-btn.button(@click="changeTkoFilter('0')") Иные
</template>

<script>
import routeMixin from '@/mixins/route-mixin'

export default {
  name: 'object-tko-filter',
  mixins: [routeMixin],
  methods: {
    changeTkoFilter(value) {
      this.replaceRoute({
        is_tko: value,
      })
      this.$emit('changeTkoFilter')
    },
    clearTkoFilter() {
      delete this.$route.query.is_tko
      this.$router.replace(this.$route, () => {})
      this.$emit('changeTkoFilter')
    },
  },
}
</script>

<style scoped lang="scss">
.objects-tko-filter {
  &__buttons {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>
